import { gql } from "@apollo/client";

export const GET_ADDRESS_INCIDENT_PEOPLE = gql`
  query GET_ADDRESS($addressId: ID!, $originatorId: ID!) {
    getAddress(addressId: $addressId, originatorId: $originatorId) {
      id
      associatedPeople {
        incidentPeople {
          incident {
            id
            incidentNumber
            locked
            sealed
            personIncidentSpecifics {
              person {
                aliases {
                  id
                  target {
                    id
                    validPersonAlerts {
                      id
                      alertType {
                        id
                        name
                        alertLevel
                      }
                    }
                  }
                }
                validPersonAlerts {
                  id
                  alertType {
                    id
                    name
                    alertLevel
                  }
                }
              }
            }
            address {
              validAddressAlerts {
                id
                alertType {
                  id
                  name
                  alertLevel
                }
              }
            }
          }
          person {
            aliases {
              id
              target {
                id
                validPersonAlerts {
                  alertType {
                    name
                    alertLevel
                  }
                }
              }
            }
            id
            personalAttribute {
              lastName
              firstName
              middleName
              mailingAddress {
                name
              }
              dob
              phone
            }
            validPersonAlerts {
              id
              alertType {
                id
                name
                alertLevel
              }
            }
          }
        }
      }
    }
  }
`;
